<i18n>
{
  "en": {},
  "zh-Hans": {
    "document-title": "免责条款与隐私协议"
  },
  "zh-Hant": {}
}
</i18n>
<template>
  <div class="disclaimer">
    <div class="main">
      <div class="name">
        免责条款与隐私协议
      </div>
      <div>
        欢迎您访问金姆健康官方应用终端，访问者在接受本平台服务之前，请务必仔细阅读下列声明。本协议是您与金姆健康平台客户端（简称“本客户端”）所有者-常州金姆健康科技有限公司及其关联方（以下简称为“金姆平台”）之间就金姆平台客户端服务等相关事宜所订立的契约，请您仔细阅读本注册协议，一旦您访问、使用了金姆健康应用终端及其提供的各项服务，即表示您同意并接受了所有该等条款、条件及通告，您点击“注册”按钮后，本协议即构成对双方有约束力的法律文件。
      </div>
      <div class="title">
        第1条 本客户端服务条款的确认和接纳
      </div>
      <div>
        1.1. 本客户端的各项电子服务的所有权和运作权归金姆平台所有。用户同意所有注册协议条款并完成注册程序，才能成为本客户端的正式用户。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。
      </div>
      <div>
        1.2. 用户确认：本协议条款是处理双方权利和义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。
      </div>
      <div>
        1.3. 用户点击同意本协议的，即视为用户确认自己具有享受本客户端服务、下单购买等相应的权利能力和行为能力，能够独立承担法律责任。
      </div>
      <div>
        1.4. 如果您在18周岁以下，您只能在父母或监护人的监护参与下才能使用本客户端。
      </div>
      <div>
        1.5. 金姆平台保留在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。
      </div>
      <div class="title">
        第2条 本客户端服务
      </div>
      <div>
        2.1. 金姆平台通过互联网依法为用户提供互联网信息等服务，用户在完全同意本协议及本客户端规定的情况下，方有权使用本客户端的相关服务。
      </div>
      <div>
        2.2. 用户必须自行准备如下设备和承担如下开支：
      </div>
      <div>  （1）上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；</div>
      <div>  （2）上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。</div>
      <div>  （3）本协议中规定的您的其他责任和义务。</div>
      <div class="title">
        第3条 用户信息
      </div>
      <div>
        3.1. 用户应自行诚信向本客户端提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果并赔偿由此给金姆平台及第三方造成的所有损失，并且金姆平台保留终止用户使用金姆平台各项服务的权利。
      </div>
      <div>
        3.2. 用户在本客户端进行购买活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，本站将予以严格保密，除非得到用户的授权或法律另有规定，本站不会向外界披露用户隐私信息。
      </div>
      <div>
        3.3. 用户注册成功后，将产生用户名和密码等账户信息，用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知本客户端并向公安机关报案。
      </div>
      <div>
        3.4. 用户同意金姆平台拥有通过邮件、短信电话等形式，向在本客户端注册、购买的用户发送订单信息、促销活动等告知信息的权利。
      </div>
      <div>
        3.5. 用户同意，金姆平台有权使用用户的注册信息、用户名、密码等信息，登陆进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。
      </div>
      <div class="title">
        第4条 用户依法言行义务
      </div>
      <div>
        本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：
      </div>
      <div>
          （1）不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；
      </div>
      <div>
          （2）从中国大陆向境外传输资料信息时必须符合中国有关法规；
      </div>
      <div>
          （3）不得利用本客户端从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
      </div>
      <div>
          （4）不得干扰本客户端的正常运转，不得侵入本客户端及国家计算机信息系统；
      </div>
      <div>
          （5）不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的、不文明的等信息资料；
      </div>
      <div>
          （6）不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；
      </div>
      <div>
          （7）不得教唆他人从事本条所禁止的行为；
      </div>
      <div>
          （8）不得利用在本客户端注册的账户进行牟利性经营活动；
      </div>
      <div>
          （9）不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容；
      </div>
      <div>
          （10）不得从事金姆平台认定的其他不当行为。
      </div>
      <div>
        用户应关注本客户端不时公布的或修改的各类合法规则规定。本客户端保有删除各类不符合法律政策或不真实的信息内容而无须通知用户的权利。若用户未遵守以上规定的，本客户端有权作出独立判断并采取暂停或关闭用户帐号等措施。用户需对自己的言论和行为承担法律责任。
      </div>
      <div class="title">
        第5条 商品信息
      </div>
      <div>
        本客户端上的服务价格、数量、能否提供等信息随时都有可能发生变动，本客户端不作特别通知。本客户端显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解；金姆平台欢迎纠错，并会视情况给予纠错者一定的奖励。为表述便利，产品和服务简称为“产品”或“服务”。
      </div>
      <div class="title">
        第6条 订单
      </div>
      <div>
        6.1. 在您下订单时，请您仔细确认所购服务的名称、价格、数量、说明、注意事项、联系地址、电话、联系人等信息。联系人与用户本人不一致的，联系人的行为和意思表示视为用户的行为和意思表示，用户应对联系人的行为及意思表示的法律后果承担连带责任。
      </div>
      <div>
        6.2. 除法律另有强制性规定外，双方约定如下：
      </div>
      <div>
          （1）本客户端上金姆平台展示的服务和价格等信息仅仅是要约邀请，您下单时须填写您希望购买的服务数量、价款及支付方式、联系人、联系方式、联系地址（合同履行地点）、合同履行方式等内容；
      </div>
      <div>
          （2）系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向金姆平台发出的合同要约；
      </div>
      <div>
          （3）金姆平台收到您的订单信息后，只有在金姆平台将您在订单中订购的服务向您或指定联系人交付时（接受服务为准），方视为您与金姆平台之间就向您或指定联系人提供的服务建立了合同关系；
      </div>
      <div>
          （4）如果您在一份订单里订购了多份服务并且金姆平台只给您或指定联系人交付了部分服务时，您与金姆平台之间仅就实际向您或指定联系人提供的服务建立了合同关系；
      </div>
      <div>
          （5）只有在金姆平台实际向您或指定联系人提供了订单中订购的其他服务时，您和金姆平台之间就订单中该其他已实际向您或指定联系人提供的服务才成立合同关系；
      </div>
      <div>
          （6）您可以随时登陆您在本客户端注册的账户，查询您的订单状态。
      </div>
      <div>
        6.3. 由于市场变化及各种以合理商业努力难以控制的因素的影响，本客户端无法保证您提交的订单信息中希望购买的服务都能提供；如您拟购买的服务，发生无法提供的情形，您有权取消订单。
      </div>
      <div>
        6.4. 本客户端仅为用户提供中文咨询及书面服务，若用户有英文服务需求，请致电本站客户服务部另行协商确定服务价格。
      </div>
      <div class="title">
        第7条 配送
      </div>
      <div>
        7.1. 金姆平台将会把产品（服务）发送到您或指定联系人所指定的接收端或邮箱等，所有在本客户端列出的交付时间为参考时间，参考时间的计算是根据具体服务的处理过程和发送时间的基础上估计得出的。
      </div>
      <div>
        7.2. 因如下情况造成订单延迟或无法交付等，金姆平台不承担延迟交付的责任：
      </div>
      <div>
          （1）用户提供的信息错误、接受端设备等原因导致的；
      </div>
      <div>
          （2）服务发送后无人查阅的；
      </div>
      <div>
          （3）情势变更因素导致的；
      </div>
      <div>
          （4）不可抗力因素导致的，例如：自然灾害、基础网络问题、突发战争、网络黑客等。
      </div>
      <div class="title">
        第8条 所有权及知识产权条款
      </div>
      <div>
        8.1. 用户一旦接受本协议，即表明该用户主动将其在任何时间段在本客户端发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容） 的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地无偿转让给金姆平台所有，用户同意金姆平台有权就任何主体侵权而单独提起诉讼。
      </div>
      <div>
        8.2. 本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及用户在金姆平台客户端上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。
      </div>
      <div>
        8.3. 用户同意并已充分了解本协议的条款，承诺不将已发表于本客户端的信息，以任何形式发布或授权其它主体以任何方式使用（包括但限于在各类网站、媒体上使用）。
      </div>
      <div>
        8.4. 金姆平台是本客户端的制作者，拥有此客户端内容及资源的著作权等合法权利，受国家法律保护，有权不时地对本协议及本客户端的内容进行修改，并在本客户端张贴，无须另行通知用户。在法律允许的最大限度范围内，金姆平台对本协议及本客户端内容拥有解释权。
      </div>
      <div>
        8.5. 除法律另有强制性规定外，未经金姆平台明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用本客户端的信息内容，否则，金姆平台有权追究其法律责任。
      </div>
      <div>
        8.6. 本客户端所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是金姆平台或其内容提供者的财产，受中国和国际版权法的保护。本客户端上所有内容的汇编是金姆平台的排他财产，受中国和国际版权法的保护。本客户端上所有软件都是金姆平台或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。
      </div>
      <div>
        8.7. 任何单位或个人认为本平台中的网页或链接内容可能涉嫌侵犯其知识产权，应该及时向本网站提出书面权利通知，并提供身份证明、权属证明及详细侵权情况证明。本平台在收到上述法律文件后，将会核实，并根据核查结果及现行有效存续之法律法规采取应对措施。
      </div>
      <div class="title">
        第9条 责任限制及不承诺担保
      </div>
      <div>
        本金姆健康应用软件可以为用户提供心包、肝、肾、脾、肺、胃、胆、膀胱经等健康指数测量，所有测量数据仅用于用户个人参考使用，不作为医院，医生诊断的依据，如因医院，医生或个人等使用本数据造成的医疗事故，本平台免责。
      </div>
      <div>
        除非另有明确的书面说明，本客户端及其所包含的或以其它方式通过本客户端提供给您的全部信息、内容、材料、产品（包括软件）和服务， 均是在“按现状”和“按现有”的基础上提供的。除非另有明确的书面说明，金姆平台不对本客户端的运营及其包含在本客户端上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。
      </div>
      <div>
        金姆平台不担保本客户端所包含的或以其它方式通过本客户端提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从本客户端发出的电子信件、信息没有病毒或其他有害成分。如因不可抗力或其它本站无法控制的原因使本客户端销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，金姆平台免责，但会合理地尽力协助处理善后事宜。
      </div>
      <div>
        金姆平台所承载的内容（文、图、视频、音频）均为传播有益健康资讯目的，不对其真实性、科学性、严肃性做任何形式保证。
      </div>
      <div>
        金姆平台拒绝回复医疗健康之外的咨询问题，包括但不限于如下情况：
      </div>
      <div>
          （1）非医疗健康类问题，如动物疾病问题、社会意识形态问题等；
      </div>
      <div>
          （2）医疗司法举证或询证问题；
      </div>
      <div>
          （3）胎儿性别鉴定问题；
      </div>
      <div>
          （4）未按提问要求提问，如提问时未指定医生，却要求具体医生回复；
      </div>
      <div>
          （5）有危害他人/自己可能的问题；
      </div>
      <div>
          （6）追问医生个人信息的问题；
      </div>
      <div>
          （7）故意挑逗、侮辱医生的提问。
      </div>
      <div>
          （8）其他法律法规规定及金姆平台认定的金姆平台拒绝回答的问题。
      </div>
      <div>
        金姆平台所有信息仅供参考，不做个别诊断、用药和使用的根据。
      </div>
      <div>
        常州金姆健康科技有限公司致力于提供正确、完整的健康资讯，但不保证信息的正确性和完整性，且不对因信息的不正确或遗漏导致的任何损失或损害承担责任。
      </div>
      <div>
        金姆平台所提供的任何医疗信息，仅供参考，不能替代医生和其他医务人员的建议，如自行使用金姆平台中资料发生偏差，常州金姆健康有限公司概不负责，亦不负任何法律责任。
      </div>
      <div>
        用户在使用此应用和做出任何医疗决定之前寻求医生的建议。
      </div>
      <div>
        以下情形导致的个人信息泄露，本平台免责
      </div>
      <div>
        （一）政府部门、司法机关等依照法定程序要求本平台披露个人资料时，本平台将根据执法单位之要求或为公共安全之目的提供个人资料；
      </div>
      <div>
        （二）由于用户将个人密码告知他人或与他人共享注册账户，由此导致的任何个人资料泄露；
      </div>
      <div>
        （三）任何由于计算机问题、黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营的不可抗力而造成的个人资料泄露、丢失、被盗用或被窜改等；
      </div>
      <div>
        （四）由于与本平台链接的其他网站所造成之个人资料泄露；
      </div>
      <div>
        常州金姆健康科技有限公司保留对本声明作出不定时修改的权利。
      </div>
      <div class="title">
        第10条 协议更新及用户关注义务
      </div>
      <div>
        根据国家法律法规变化及网络运营需要，金姆平台有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在本客户端上即生效，并代替原来的协议。用户可随时登陆查阅最新协议；用户有义务不时关注并阅读最新版的协议及客户端公告。如用户不同意更新后的协议，可以且应立即停止接受金姆平台客户端依据本协议提供的服务；如用户继续使用本客户端提供的服务，即视为同意更新后的协议。金姆平台建议您在使用本客户端之前阅读本协议及本客户端的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
      </div>
      <div class="title">
        第11条 法律管辖和适用
      </div>
      <div>
        本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向金姆平台所有者所在地有管辖权的中华人民共和国大陆地区法院提起诉讼。
      </div>
      <div class="title">
        第12条 其他
      </div>
      <div>
        12.1. 金姆平台客户端所有者是指在政府部门依法许可或备案的金姆平台经营主体。
      </div>
      <div>
        12.2. 金姆平台尊重用户和消费者的合法权利，本协议及本客户端上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。本客户端欢迎用户和社会各界提出意见和建议，金姆平台将虚心接受并适时修改本协议及本客户端的各类规则。
      </div>
      <div>
        12.3. 除本平台注明之服务条款外，其他一切因使用本平台而引致之任何意外、疏忽、诽谤、版权或知识产权侵犯及其所造成的损失，本平台不承担任何法律责任。
      </div>
      <div>
        12.4. 本平台之声明以及其修改权、更新权及最终解释权均属本站所有。
      </div>
      <div>
        12.5. 在点击下一步之前请您再次确认已知悉并完全理解本协议的全部内容。
      </div>
      <div>
        12.6. SDK 使用说明 <br>
        <br>
        平台名称：腾讯<br>
        使用SDK名称：腾讯 Bugly<br>
        服务类型：判断当前进程的ANR状态，排查崩溃问题,帮助APP提升稳定性<br>
        收集个人信息类型：ICCID、SIM序列号、Android_ID、设备MAC地址、软件安装列表，手机型号、手机品牌、Android系统版本、Android系统api等级、厂商系统版本、cpu架构类型、设备是否root、磁盘空间占用大小、sdcard空间占用大小、内存空间占用大小、网络类型、应用当前正在运行的进程名和PID（仅读取，不保存到本地，也不上传服务器）<br>
        隐私权政策链接：https://static.bugly.qq.com/bugly-sdk-privacy-statement.pdf<br>
        <br>
        使用SDK名称：MobTech ShareSDK<br>
        场景描述：为App赋予社会化分享的能力<br>
        收集个人信息的类型：Android_ID、已安装APP信息、系统运行信息、网络状态信息、iOS广告标识符（IDFA）、国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI）、应用列表信息、基站信息、社交平台OpenID、地理位置<br>
        第三方机构名称：上海游昆信息技术有限公司<br>
        用途或目的：社交分享，第三方登录<br>
        是否为必要信息：是<br>
        数据是否加密传输：是<br>
        第三方隐私政策链接：www.mob.com/about/policy<br>
        <br>
        Fresco框架  com.facebook.fresco<br>
        使用目的：用于加载应用内的图片。功能类型：加载图片。<br>
        涉及收集个人信息：本SDK不会收集用户的隐私信息。<br>
        隐私政策/官网地址：https://www.fresco-cn.org/<br>
      </div>
      <div>
        12.7. 账户注销说明<br>
        账户注销需要用户主动联系客服进行注销，我们将在三个工作日内完成注销<br>
      </div>
      <div>
        12.8. App所需权限说明<br>
        蓝牙权限，用于连接我们的蓝牙设备进行数据交互<br>
        定位信息，用于蓝牙设备搜索<br>
        安装权限，用于app更新升级<br>
        <br>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'disclaimer',
  data () {
    return {
    }
  },
  computed: {
  },
  beforeMount () {
  },
  mounted () {
    const t = this
    t.$store.dispatch('changeTitle', t.$t('document-title'))
    t.$store.dispatch('invokeBridgeMethod', 'showSignInNavigationBar').then((dsBridge) => {
      dsBridge.call('showSignInNavigationBar', {
        enabledShow: true,
        navigationBarTitle: 'legalProvisionAndPrivacy'
      })
    }).catch(() => {})
    t.$store.state.loading = false
  },
  destroyed () {
  },
  methods: {
  },
  components: {
  }
}
</script>
<style scoped>
  .name {
    text-align: center;
    padding: 20px 0;
  }
  .mobile-phone .name {
    font-size: calc(20 / 375 * 100vw);
    font-weight: 700;
  }
  .landscape .name {
    font-size: calc(20 / 375 * 100vh);
  }
  .disclaimer {
    background-color: #ffffff;
    text-align: center;
    padding: 0 calc(15 / 375 * 100vw);
  }
  .landscape .disclaimer {
    padding: 0 calc(20 / 375 * 100vh);
  }
  .main {
    text-align: left;
    display: inline-block;
    width: calc(1116 / 16 * 1rem);
    padding-bottom: 20px;
  }
  .mobile-phone .main {
    width: 100%;
  }
  .mobile-phone.disclaimer {
    background-color: #ffffff;
    padding: calc(20 / 375 * 100vw) calc(15 / 375 * 100vw);
    box-sizing: border-box;
  }
  .mobile-phone.disclaimer div {
    padding-bottom: calc(10 / 375 * 100vw);
  }
  .mobile-phone .title {
    padding: calc(30 / 375 * 100vw) 0;
  }
</style>
